import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { CommIFStatus } from '@models/system-status';
import { SystemStatusRoutingService } from '@service/system-status-routing.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-comms-status',
    templateUrl: './comms-status.component.html',
    styleUrls: ['./comms-status.component.scss'],
    standalone: false
})
export class CommsStatusComponent implements OnInit, OnDestroy, OnChanges {
    @Input() isReceivingData: boolean;
    @Input() commIFArray: CommIFStatus[];
    @Input() selectedComm: CommIFStatus;
    @Output() onSelectCommIf: EventEmitter<CommIFStatus> = new EventEmitter<CommIFStatus>();

    selectedCommIFSubscription: Subscription;
    private selectedCommIFIndex: number;

    constructor(private systemStatusRoutingService: SystemStatusRoutingService) {}

    ngOnInit(): void {
        this.selectedCommIFSubscription = this.systemStatusRoutingService
            .selectedCommIFIndexSubject()
            .subscribe((commIFIndex) => {
                if (this.commIFArray) {
                    this.selectedComm = this.commIFArray[commIFIndex];
                }
            });
    }

    ngOnChanges(changes) {
        if (changes.commIFArray) {
            this.onSelectCommIf.emit(this.commIFArray[this.selectedCommIFIndex]);
        }
        if (changes.selectedComm) {
            this.selectedCommIFIndex = this.commIFArray.indexOf(this.selectedComm);
        }
    }

    ngOnDestroy(): void {
        this.selectedCommIFSubscription?.unsubscribe();
    }

    handleSelectedCommsIF(commIF: CommIFStatus) {
        this.selectedComm = commIF;
        this.selectedCommIFIndex = this.commIFArray.indexOf(commIF);
        this.onSelectCommIf.emit(commIF);
    }
}
